import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-award-dashboard',
  templateUrl: './award-dashboard.component.html',
  styleUrls: ['./award-dashboard.component.css']
})
export class AwardDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
